import { Box } from 'grommet';
import React, { FC } from 'react';
import { DollarSign, Clipboard, Home, Folder } from 'react-feather';

import SidebarItem from './SidebarItem';
import SidebarItemSignOut from './SidebarItemSignOut';
import SidebarListSeparator from './SidebarListSeparator';

interface Props {
  mobile?: boolean;
  onClick: () => void;
}

const SidebarListInternals: FC<Props> = ({ onClick, mobile = false }) => {
  return (
    <>
      <Box flex={false}>
        <SidebarItem
          Icon={Home}
          path="/"
          mobile={mobile}
          onClick={onClick}
          text="Tableau de bord"
        />

        <SidebarItem
          Icon={DollarSign}
          path="/quotes"
          mobile={mobile}
          onClick={onClick}
          text="Soumissions"
        />

        <SidebarItem
          Icon={Clipboard}
          path="/projects"
          mobile={mobile}
          onClick={onClick}
          text="Projets"
        />

        <SidebarItem
          Icon={Folder}
          path="/files/general"
          mobile={mobile}
          onClick={onClick}
          text="Bibliothèque"
        />
      </Box>

      <SidebarListSeparator />

      <Box flex={false}>
        <SidebarItemSignOut mobile={mobile} />
      </Box>
    </>
  );
};

export default SidebarListInternals;
